import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MainLayout from '../components/layouts/MainLayout';
import DoorlockList from '../components/views/doorlocks/DoorlockList';
import Spin from '../components/Spin';
import { doorlockListAction } from '../stores/actions';
import * as api from '../api';
import useDebounce from '../lib/useDebounce';

const DoorlockListContainer = ({history}) => {
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isDebounce, setIsDebounce ] = useState(false); //디바운싱 사용 구분을 위해 추가
  const hotelId = localStorage.getItem('hotel_id');
  const [ buildingListItems, setBuildingListItems ] = useState([]);
  const [ floorListItems, setFloorListItems ] = useState([]);
  const { doorlockListTotal, doorlockListItems, currentPageNumber, paginationItem, sortItem, filterItem } = useSelector(state => state.doorlockList);
  const { doorlockDeletable } = useSelector(state => state.sidebar);
  const dispatch = useDispatch();

  const setDoorlockList = useCallback((doorlockList) => {
    dispatch(doorlockListAction.setDoorlockList(doorlockList));
  }, [dispatch]);

  const setCurrentPageNumber = useCallback((currentPageNumber) => {
    dispatch(doorlockListAction.setCurrentPageNumber(currentPageNumber));
  }, [dispatch]);

  const setPaginationItem = useCallback((paginationItem) => {
    dispatch(doorlockListAction.setPaginationItem(paginationItem));
  }, [dispatch]);

  const setSortItem = useCallback((sortItem) => {
    dispatch(doorlockListAction.setSortItem(sortItem));
  }, [dispatch]);

  const setFilterItem = useCallback((filterItem, isDebounce) => {
    setIsDebounce(isDebounce); //디바운싱 처리를 위해 하위 Component에서 구분을 받아옴
    dispatch(doorlockListAction.setFilterItem(filterItem));
  }, [dispatch]);

  const changeHotel = useCallback(() => {
    dispatch(doorlockListAction.initDoorlockListState());
  }, [dispatch]);

  const listBuilding = useCallback(async () => {
    try {
      const res = await api.listBuilding({});
      setBuildingListItems(res.data.items);
    } catch (error) {
      throw error;
    }
  }, []);

  const listFloor = useCallback(async () => {
    try {
      if (!filterItem.buildingId) {
        setFloorListItems([]);
      };
      const res = await api.listFloor({buildingId:filterItem.buildingId});
      setFloorListItems(res.data.items);
    } catch (error) {
      throw error;
    }
  }, [filterItem]);

  const listDoorlock = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await api.listDoorlock({...filterItem, ...sortItem, ...paginationItem});
      setDoorlockList(res.data);
    } catch (error) {
      setDoorlockList({
        total: 0,
        items: [],
      });
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [setDoorlockList, filterItem, sortItem, paginationItem]);

  //디바운싱 훅으로 이동
  const handleDebounce = useCallback(
    useDebounce((listDoorlock) => listDoorlock(), 300) //0.3초 동안 미입력 시 함수 실행
  ,[]);

  useEffect(() => {
    try {
      listBuilding();
    } catch (error) {
      throw error;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hotelId]);
  
  useEffect(() => {
    try {
      if(filterItem.buildingId) listFloor();
    } catch (error) {
      throw error;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterItem.buildingId]);
  
  useEffect(() => {
    try {
      !isDebounce? listDoorlock() : handleDebounce(listDoorlock); //디바운싱 처리
    } catch (error) {
      throw error;
    }
  }, [handleDebounce, isDebounce, listDoorlock]);

  return (
    <Fragment>
      <Spin isSpin={isLoading}/>
      <MainLayout
        history={history}
        refresh={changeHotel}
        ContentBody={(
          <Fragment>
            <DoorlockList
              doorlockListTotal={doorlockListTotal}
              doorlockListItems={doorlockListItems}
              buildingListItems={buildingListItems}
              floorListItems={floorListItems}
              filterItem={filterItem}
              sortItem={sortItem}
              paginationItem={paginationItem}
              currentPageNumber={currentPageNumber}
              doorlockDeletable={doorlockDeletable}
              listDoorlockApi={listDoorlock}
              setFilterItem={setFilterItem}
              setSortItem={setSortItem}
              setPaginationItem={setPaginationItem}
              setCurrentPageNumber={setCurrentPageNumber}
              history={history}
            />
          </Fragment>
        )}
      />
    </Fragment>
  );
}

export default DoorlockListContainer;